<template>
  <!-- Główny kontener filtrów statystycznych -->
  <div class="filters-container">
    <!-- Komponent legendy wyświetlający opis używanych ikon/statusów -->
    <legend-list />

    <!-- Filtr po lokalizacjach (np. stacje preselekcji) -->
    <locations-filter-view :store="filtersStore" />

    <!-- Filtr zakresu dat (kiedy pobierać dane/statystyki) -->
    <date-range-filter-view :store="filtersStore" />

    <!-- Filtr rozdzielczości (np. dzienna, godzinowa, tygodniowa agregacja) -->
    <resolution-filter-view :store="filtersStore" />

    <!-- Filtr po nazwie statystyki (typ wykresu/statystyki, np. liczba pojazdów, masa) -->
    <stat-name-filter-view :store="filtersStore" />

    <!-- Filtr po numerach pasów (np. 1, 2, 3, 4) -->
    <lane-numbers-filter-view :store="filtersStore" />

    <!-- Filtr kategorii pojazdów (np. ciężarówki, autobusy, osobowe) -->
    <vehicle-categories-filter-view
        v-if="!isSG"
        :store="filtersStore"
    />

    <!-- Filtr naruszeń/przekroczeń (np. przeciążenia, prędkość) -->
    <violation-filter-view :store="filtersStore" />

    <!-- Wybór grupowania danych (np. po lokalizacji, po dacie, po kategorii pojazdu) -->
    <group-by-filter-view :store="filtersStore" />

    <!-- Wybór typu wykresu/statystyki (np. wykres słupkowy, liniowy, kołowy) -->
    <graph-type-filter-view :store="filtersStore" />
  </div>
</template>

<script>
// Importujemy Pinia store do przechowywania stanu filtrów statystycznych
import { useStatisticFiltersStore } from "@/stores/statisticFilters";
// Import wszystkich komponentów filtrujących, każdy realizuje pojedynczy filtr
import LocationsFilterView from "./filters/LocationsFilterView.vue";
import DateRangeFilterView from "./filters/DateRangeFilterView.vue";
import LaneNumbersFilterView from "./filters/LaneNumbersFilterView.vue";
import VehicleCategoriesFilterView from "./filters/VehicleCategoriesFilterView.vue";
import ViolationFilterView from "./filters/ViolationFilterView.vue";
import ResolutionFilterView from "./statistics/ResolutionFilterView.vue";
import GroupByFilterView from "./statistics/GroupByFilterView.vue";
import GraphTypeFilterView from "./statistics/GraphTypeFilterView.vue";
import StatNameFilterView from "./statistics/StatNameFilterView.vue";
import LegendList from "./filters/LegendList.vue";
import { isSG } from "@/config/appVersion";

export default {
  name: "FilterStatisticData",
  // Rejestrujemy wszystkie komponenty filtrujące jako child components
  components: {
    LocationsFilterView,
    DateRangeFilterView,
    VehicleCategoriesFilterView,
    ViolationFilterView,
    LaneNumbersFilterView,
    ResolutionFilterView,
    GroupByFilterView,
    GraphTypeFilterView,
    StatNameFilterView,
    LegendList,
  },
  setup() {
    // Inicjalizujemy store Pinia na potrzeby filtrów (reaktywna zmienna)
    const filtersStore = useStatisticFiltersStore();
    // Zwracamy do template
    return { filtersStore, isSG };
  },
};
</script>

<style scoped>
/* Styl głównego kontenera filtrów - szerokość i tło */
.filters-container {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}
</style>
